'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

// Mock data for frontend testing
const MOCK_AUDIOBOOKS = [
  {
    id: 1,
    title: 'The Pilgrim\'s Progress',
    author: 'John Bunyan',
    narrator: 'David Cochran Heath',
    coverImageUrl: null,
    category: 'Christian Classics',
    durationHours: 8,
    durationMinutes: 30,
    totalChapters: 15,
    isFree: true,
    description: 'A Christian allegory following the journey of Christian from the City of Destruction to the Celestial City'
  },
  {
    id: 2,
    title: 'Mere Christianity',
    author: 'C.S. Lewis',
    narrator: 'Geoffrey Howard',
    coverImageUrl: null,
    category: 'Christian Apologetics',
    durationHours: 6,
    durationMinutes: 45,
    totalChapters: 12,
    isFree: true,
    description: 'A theological book by C. S. Lewis, adapted from a series of BBC radio talks made between 1941 and 1944'
  },
  {
    id: 3,
    title: 'The Cost of Discipleship',
    author: 'Dietrich Bonhoeffer',
    narrator: 'Simon Vance',
    coverImageUrl: null,
    category: 'Christian Living',
    durationHours: 7,
    durationMinutes: 15,
    totalChapters: 18,
    isFree: false,
    description: 'Explores what it means to follow Christ in a modern world'
  },
  {
    id: 4,
    title: 'Knowing God',
    author: 'J.I. Packer',
    narrator: 'Robertson Dean',
    coverImageUrl: null,
    category: 'Theology',
    durationHours: 9,
    durationMinutes: 0,
    totalChapters: 22,
    isFree: true,
    description: 'An exploration of the character and attributes of God'
  },
  {
    id: 5,
    title: 'The Screwtape Letters',
    author: 'C.S. Lewis',
    narrator: 'Joss Ackland',
    coverImageUrl: null,
    category: 'Christian Fiction',
    durationHours: 4,
    durationMinutes: 20,
    totalChapters: 31,
    isFree: true,
    description: 'A satirical Christian apologetic novel exploring temptation and spiritual warfare'
  },
  {
    id: 6,
    title: 'The Purpose Driven Life',
    author: 'Rick Warren',
    narrator: 'Rick Warren',
    coverImageUrl: null,
    category: 'Christian Living',
    durationHours: 8,
    durationMinutes: 50,
    totalChapters: 42,
    isFree: false,
    description: 'A 40-day spiritual journey that will transform your answer to life\'s most important question'
  },
  {
    id: 7,
    title: 'The Holiness of God',
    author: 'R.C. Sproul',
    narrator: 'George W. Sarris',
    coverImageUrl: null,
    category: 'Theology',
    durationHours: 5,
    durationMinutes: 30,
    totalChapters: 10,
    isFree: true,
    description: 'A profound look at the nature of God\'s holiness and its implications'
  },
  {
    id: 8,
    title: 'Heaven',
    author: 'Randy Alcorn',
    narrator: 'Wayne Shepherd',
    coverImageUrl: null,
    category: 'Christian Doctrine',
    durationHours: 18,
    durationMinutes: 0,
    totalChapters: 45,
    isFree: false,
    description: 'A comprehensive study of what the Bible reveals about our eternal home'
  },
  {
    id: 9,
    title: 'The Knowledge of the Holy',
    author: 'A.W. Tozer',
    narrator: 'Simon Vance',
    coverImageUrl: null,
    category: 'Theology',
    durationHours: 4,
    durationMinutes: 15,
    totalChapters: 11,
    isFree: true,
    description: 'A classic book about God\'s character and attributes'
  },
  {
    id: 10,
    title: 'The Pursuit of God',
    author: 'A.W. Tozer',
    narrator: 'Simon Vance',
    coverImageUrl: null,
    category: 'Christian Living',
    durationHours: 3,
    durationMinutes: 45,
    totalChapters: 10,
    isFree: true,
    description: 'A powerful exploration of the Christian life and our relationship with God'
  },
  {
    id: 11,
    title: 'Basic Christianity',
    author: 'John Stott',
    narrator: 'Paul Michael Garcia',
    coverImageUrl: null,
    category: 'Christian Apologetics',
    durationHours: 5,
    durationMinutes: 20,
    totalChapters: 8,
    isFree: true,
    description: 'A clear introduction to the Christian faith'
  },
  {
    id: 12,
    title: 'The Problem of Pain',
    author: 'C.S. Lewis',
    narrator: 'Geoffrey Howard',
    coverImageUrl: null,
    category: 'Christian Apologetics',
    durationHours: 5,
    durationMinutes: 50,
    totalChapters: 10,
    isFree: false,
    description: 'An examination of the problem of suffering and God\'s goodness'
  },
  {
    id: 13,
    title: 'The Great Divorce',
    author: 'C.S. Lewis',
    narrator: 'Simon Vance',
    coverImageUrl: null,
    category: 'Christian Fiction',
    durationHours: 4,
    durationMinutes: 0,
    totalChapters: 14,
    isFree: true,
    description: 'A theological fantasy about heaven and hell'
  },
  {
    id: 14,
    title: 'Desiring God',
    author: 'John Piper',
    narrator: 'Robertson Dean',
    coverImageUrl: null,
    category: 'Christian Living',
    durationHours: 10,
    durationMinutes: 30,
    totalChapters: 13,
    isFree: false,
    description: 'Meditations of a Christian hedonist on joy in God'
  },
  {
    id: 15,
    title: 'The Reason for God',
    author: 'Timothy Keller',
    narrator: 'Tom Parks',
    coverImageUrl: null,
    category: 'Christian Apologetics',
    durationHours: 9,
    durationMinutes: 15,
    totalChapters: 14,
    isFree: true,
    description: 'Belief in an age of skepticism'
  },
  {
    id: 16,
    title: 'The Prodigal God',
    author: 'Timothy Keller',
    narrator: 'Tom Parks',
    coverImageUrl: null,
    category: 'Christian Living',
    durationHours: 3,
    durationMinutes: 30,
    totalChapters: 7,
    isFree: true,
    description: 'Recovering the heart of the Christian faith'
  }
];

export default function AudioBookLibrary() {
  const [audiobooks, setAudiobooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [viewMode, setViewMode] = useState('grid');

  const itemsPerPage = 12;

  // Load mock data on component mount
  useEffect(() => {
    // Simulate API call delay
    const timer = setTimeout(() => {
      setAudiobooks(MOCK_AUDIOBOOKS);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Filter audiobooks based on search and category
  const filteredAudiobooks = audiobooks?.filter((book) => {
    const matchesSearch =
      book?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      book?.author?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      book?.narrator?.toLowerCase()?.includes(searchQuery?.toLowerCase());

    const matchesCategory =
      selectedCategory === 'All' || book?.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  // Get unique categories
  const categories = [
    'All',
    ...new Set(audiobooks.map((book) => book.category).filter(Boolean)),
  ];

  // Calculate pagination
  const totalPages = Math.ceil(filteredAudiobooks?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedAudiobooks = filteredAudiobooks?.slice(startIndex, startIndex + itemsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const formatDuration = (hours, minutes) => {
    const h = Number(hours) || 0;
    const m = Number(minutes) || 0;

    if (h === 0 && m === 0) return '0h 0m';
    if (h === 0) return `${m}m`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}m`;
  };

  // ----- Loading state -----
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#4b3381]" />
              <p className="mt-4 text-gray-600">Loading audiobooks...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ----- Main UI -----
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Enhanced Header with gradient */}
      <div className="bg-gradient-to-r from-[#4b3381] via-[#5d4499] to-[#6b54a9] text-white">
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-4 tracking-tight">
              Audio Book Library
            </h1>
            <p className="text-xl text-blue-100 mb-8">
              Discover {audiobooks?.length} inspiring audio books
            </p>

            {/* Search Bar - moved to header */}
            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search by title, author, or narrator..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)}
                  className="w-full px-6 py-4 pr-12 rounded-full text-gray-800 placeholder-gray-500 shadow-lg focus:outline-none focus:ring-4 focus:ring-white/30 transition-all"
                />
                <svg
                  className="absolute right-5 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Filters and View Controls */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8 bg-white p-4 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            {/* Category Filter */}
            <div className="relative">
              <select
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e?.target?.value);
                  setCurrentPage(1);
                }}
                className="appearance-none bg-white border-2 border-gray-200 rounded-lg px-4 py-2 pr-10 text-gray-700 font-medium focus:outline-none focus:border-[#4b3381] transition-colors cursor-pointer"
              >
                {categories?.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
              <svg
                className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>

            {/* Results Count */}
            <span className="text-gray-600 font-medium">
              {filteredAudiobooks?.length} {filteredAudiobooks?.length === 1 ? 'book' : 'books'}
            </span>
          </div>

          {/* View Mode Toggle */}
          <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => setViewMode('grid')}
              className={`p-2 rounded-md transition-all ${
                viewMode === 'grid' ? 'bg-white text-[#4b3381] shadow-sm' : 'text-gray-500 hover:text-gray-700'
              }`}
              aria-label="Grid view"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </button>
            <button
              onClick={() => setViewMode('list')}
              className={`p-2 rounded-md transition-all ${
                viewMode === 'list' ? 'bg-white text-[#4b3381] shadow-sm' : 'text-gray-500 hover:text-gray-700'
              }`}
              aria-label="List view"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>

        {filteredAudiobooks?.length === 0 ? (
          <div className="text-center py-16">
            <div className="text-gray-400 mb-4">
              <svg
                className="w-24 h-24 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-700 mb-2">
              No audiobooks found
            </h3>
            <p className="text-gray-500 mb-6">
              Try adjusting your search or filter criteria
            </p>
            <button
              onClick={() => {
                setSearchQuery('');
                setSelectedCategory('All');
              }}
              className="px-6 py-3 bg-[#4b3381] text-white rounded-lg hover:bg-[#5d4499] transition-colors font-medium"
            >
              Clear Filters
            </button>
          </div>
        ) : (
          <>
            {/* Audiobooks Grid/List */}
            <div
              className={
                viewMode === 'grid' ?'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12' :'space-y-4 mb-12'
              }
            >
              {paginatedAudiobooks?.map((book) => (
                <div
                  key={book?.id}
                  className={`bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-2xl transition-all duration-300 group ${
                    viewMode === 'list' ? 'flex' : ''
                  }`}
                >
                  {/* Cover */}
                  <div
                    className={`relative bg-gradient-to-br from-[#4b3381] to-[#5d4499] ${
                      viewMode === 'list' ? 'w-32 flex-shrink-0' : 'h-64'
                    }`}
                  >
                    {book?.coverImageUrl ? (
                      <img
                        src={book?.coverImageUrl}
                        alt={`${book?.title} audiobook cover`}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <svg
                          className="w-16 h-16 text-white opacity-50"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                          />
                        </svg>
                      </div>
                    )}

                    {/* Play Overlay - only in grid view */}
                    {viewMode === 'grid' && (
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                        <button className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white rounded-full p-5 shadow-2xl transform group-hover:scale-110">
                          <svg
                            className="w-10 h-10 text-[#4b3381]"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </button>
                      </div>
                    )}

                    {/* Free Badge */}
                    {book?.isFree && (
                      <div className="absolute top-3 left-3 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                        FREE
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div className={`p-5 ${viewMode === 'list' ? 'flex-1' : ''}`}>
                    <h3 className="text-lg font-bold text-gray-800 mb-2 line-clamp-2 group-hover:text-[#4b3381] transition-colors">
                      <Link href={`/single-audio-book-details?id=${book?.id}`}>
                        {book?.title}
                      </Link>
                    </h3>
                    <p className="text-gray-600 text-sm mb-1 font-medium">
                      {book?.author}
                    </p>
                    {book?.narrator && (
                      <p className="text-gray-500 text-xs mb-3">
                        <span className="font-medium">Narrated by</span> {book?.narrator}
                      </p>
                    )}

                    {/* Duration & chapters */}
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                      <div className="flex items-center gap-1">
                        <svg
                          className="w-4 h-4 text-[#4b3381]"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span className="font-medium">
                          {formatDuration(
                            book?.durationHours,
                            book?.durationMinutes
                          )}
                        </span>
                      </div>
                      {book?.totalChapters > 0 && (
                        <div className="flex items-center gap-1">
                          <svg
                            className="w-4 h-4 text-[#4b3381]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                            />
                          </svg>
                          <span className="font-medium">{book?.totalChapters}</span>
                        </div>
                      )}
                    </div>

                    {/* Category */}
                    {book?.category && (
                      <span className="inline-block bg-[#4b3381]/10 text-[#4b3381] px-3 py-1 rounded-full text-xs font-semibold">
                        {book?.category}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Enhanced Pagination */}
            {totalPages > 1 && (
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pb-12">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
                    currentPage === 1
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed' :'bg-white text-[#4b3381] hover:bg-[#4b3381] hover:text-white shadow-md hover:shadow-xl transform hover:-translate-x-1'
                  }`}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Previous
                </button>

                <div className="flex items-center gap-2">
                  <span className="px-4 py-2 bg-[#4b3381] text-white rounded-xl font-bold shadow-lg">
                    {currentPage}
                  </span>
                  <span className="text-gray-500 font-medium">of</span>
                  <span className="px-4 py-2 bg-white text-gray-700 rounded-xl font-bold shadow-md">
                    {totalPages}
                  </span>
                </div>

                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
                    currentPage === totalPages
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed' :'bg-white text-[#4b3381] hover:bg-[#4b3381] hover:text-white shadow-md hover:shadow-xl transform hover:translate-x-1'
                  }`}
                >
                  Next
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}